/** Same breakpoint as Sidebar mobile drawer */
export const DASHBOARD_MOBILE_MAX_WIDTH = 1024;

const LOADER_VISIBLE_MS = 480;

/**
 * On narrow viewports, show a fullscreen loader while document direction flips,
 * avoiding a visible sidebar slide. On desktop, runs `applyNext` immediately.
 * @param {{ forceLoader?: boolean }} [options] — when `forceLoader` is true, always show the loader (e.g. catalog studio language toggle on desktop).
 */
export function runMobileLanguageDirectionTransition(setShowLoader, applyNext, options = {}) {
  const force = Boolean(options?.forceLoader);
  const isMobile =
    typeof window !== "undefined" && window.innerWidth <= DASHBOARD_MOBILE_MAX_WIDTH;

  if (!force && !isMobile) {
    applyNext();
    return;
  }

  setShowLoader(true);
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      applyNext();
      window.setTimeout(() => setShowLoader(false), LOADER_VISIBLE_MS);
    });
  });
}
